module.exports = __webpack_public_path__ + "img/private_sector_team.2c61796f.jpg";